module.exports = __webpack_public_path__ + "static/media/Pigtail-Spring_355x237.8e14ffe5.jpg";